.errorBoundaryContentContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 400px;
    padding-top: 75px;

    .errorBoundaryHeader {
        font-weight: 700;
    }

    .actionsContainer {
        text-align: left;
        display: flex;
        flex-direction: column;

        .buttonContainer {
            height: 38px;
            button {
                background: none;
                border: none;
                cursor: pointer;
                font-size: 18px;
                align-self: flex-start;
                &:hover {
                    text-decoration: underline;
                    color: rgba(0, 0, 0, 0.5);
                }
            }
            i {
                margin-right: 10px;
                font-size: 24px;
                color: #57c1e9;
                &:hover {
                    text-decoration: none;
                }
            }
        }
    }

    .errorBoundaryStackTrace {
        padding: 1em;
        margin-top: 40px;
        align-self: normal;
    }
}
